import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getWebsiteUrl } from "../../utils/content";

class SkipAPayUnavailableComponent extends Component {

    render() {
        var reason = 'We couldn’t process this Skip-A-Pay request. Give our Contact Center a call at <a class="give-us-a-call" href="tel:+18882677200">888.267.7200</a> and let’s figure out what’s going on. Talk to you soon!';
        return (
            <div className="error-page">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="error-container">
                                <h1>Well, That's A Bummer</h1>
                                <p dangerouslySetInnerHTML={{ __html: reason }} />
                                <a href={getWebsiteUrl()} className="button tertiary">
                                    GO TO LAKETRUST.ORG
                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

// Map global store to component props
const mapStateToProps = state => state;

// Hook up actions to component
const mapDispatchToProps = {
};

//Connect to Redux store
const SkipAPayUnavailable = withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(SkipAPayUnavailableComponent)
);

export default SkipAPayUnavailable;



// WEBPACK FOOTER //
// ./src/components/skip-a-pay-unavailable/skip-a-pay-unavailable.component.js